<p-splitButton
  #splitOptions
  [label]="activeItem"
  appendTo="body"
  [icon]="activeIcon"
  [model]="items"
  class="bfx-button-secondary-bold bfx-button-sm temperature-dropdown"
  menuStyleClass="bfx-dashboard-menu"
  (onClick)="showMenu()"
>
</p-splitButton>
